import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';
import Ellipse from '@splunk/dashboard-visualizations/Ellipse';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import StrokeExampleCode from '!!raw-loader!./examples/Stroke';
import StrokeWidthExampleCode from '!!raw-loader!./examples/StrokeWidth';
import FillExampleCode from '!!raw-loader!./examples/Fill';
import FillOpacityExampleCode from '!!raw-loader!./examples/FillOpacity';
import StrokeDasharrayExampleCode from '!!raw-loader!./examples/StrokeDasharray';
import StrokeFillEncodingCode from '!!raw-loader!./examples/StrokeFillEncoding';
import FillEncodingCode from '!!raw-loader!./examples/FillEncoding';
import StrokeEncodingCode from '!!raw-loader!./examples/StrokeEncoding';

import BasicExample from './examples/Basic';
import StrokeExample from './examples/Stroke';
import StrokeWidthExample from './examples/StrokeWidth';
import FillExample from './examples/Fill';
import FillOpacityExample from './examples/FillOpacity';
import StrokeDasharrayExample from './examples/StrokeDasharray';
import StrokeFillEncodingExample from './examples/StrokeFillEncoding';
import FillEncodingExample from './examples/FillEncoding';
import StrokeEncodingExample from './examples/StrokeEncoding';
import doc from './definition';
import optionsSchema from '../optionsSchema';

function EllipseDoc() {
    return (
        <VisualizationDocPage
            title="Ellipse"
            examplesSection={[
                <DocExample
                    title="Basic Ellipse"
                    key="basic_Ellipse"
                    description="Default stroke, fill and opacity"
                    code={BasicExampleCode}
                    example={BasicExample}
                />,
                <DocExample
                    title="Stroke Ellipse"
                    key="stroke_Ellipse"
                    description="Ellipse Stroke is red"
                    code={StrokeExampleCode}
                    example={StrokeExample}
                />,
                <DocExample
                    title="Stroke Width and Opacity Ellipse"
                    key="stroke_width_Ellipse"
                    description="Ellipse Stroke Width is 5, Ellipse Stroke Opacity is 0.5"
                    code={StrokeWidthExampleCode}
                    example={StrokeWidthExample}
                />,
                <DocExample
                    title="Fill Ellipse"
                    key="fill_Ellipse"
                    description="Ellipse Fill is blue"
                    code={FillExampleCode}
                    example={FillExample}
                />,
                <DocExample
                    title="Fill and Opacity Ellipse"
                    key="fillopacity"
                    description="Ellipse Fill is cyan, Ellipse Fill Opacity is 0.5"
                    code={FillOpacityExampleCode}
                    example={FillOpacityExample}
                />,
                <DocExample
                    title="Stroke Dash Array Ellipse"
                    key="stroke_dasharray_Ellipse"
                    description="Ellipse Stroke Dash Array is 5"
                    code={StrokeDasharrayExampleCode}
                    example={StrokeDasharrayExample}
                />,
                <DocExample
                    title="Fill and Stroke Encoding"
                    key="strokefillencoding"
                    description="Fill Encoding is blue, Stroke Encoding is purple"
                    code={StrokeFillEncodingCode}
                    example={StrokeFillEncodingExample}
                />,
                <DocExample
                    title="Fill Encoding"
                    key="fill_encoding"
                    description="Fill Encoding is blue"
                    code={FillEncodingCode}
                    example={FillEncodingExample}
                />,
                <DocExample
                    title="Stroke Encoding"
                    key="stroke_encoding"
                    description="Stroke Encoding is purple"
                    code={StrokeEncodingCode}
                    example={StrokeEncodingExample}
                />,
            ]}
            encodingSection={<EncodingDoc encoding={doc.encoding} />}
            optionSection={<OptionsDoc options={optionsSchema} />}
            eventSection={
                <EventsDoc
                    options={{}}
                    events={doc.events}
                    Visualization={Ellipse}
                    encoding={{}}
                    dsState={{
                        primary: {
                            data: {
                                columns: [
                                    ['1', '62', '103', '308', '587', '876', '930', '1320'],
                                    [
                                        '#FF0000',
                                        '#00FFFF',
                                        '#0000FF',
                                        '#800080',
                                        '#FFFF00',
                                        '#FFA500',
                                        '#A52A2A',
                                        '#008000',
                                    ],
                                ],
                                fields: [
                                    {
                                        name: 'count',
                                    },
                                    {
                                        name: 'color',
                                    },
                                ],
                            },
                            meta: {},
                        },
                    }}
                />
            }
        />
    );
}

export default EllipseDoc;
